import { MdRedeem } from 'react-icons/md';
import { Resources } from '../../resource';
import { MainPage } from './main-page';

export const name = Resources.worldCupManualIssue;

export const list = MainPage;

export const icon = MdRedeem;

export const options = { label: 'resource.worldCupManualIssue' };
